import type { TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';
import { parseWithEndTag } from './baseParser';

class UnderlinedTagParser implements TagParser {
  tag = 'onderstreept_aan';

  parse(text: string) {
    const endTag = 'onderstreept_uit';
    const parsedTextResult = parseWithEndTag(text, endTag);

    return {
      html: `<span class="underline">${parsedTextResult.parsedText}</span>`,
      consumedLength: parsedTextResult.consumedLength,
    };
  }
}

ParserRegistry.register(new UnderlinedTagParser());
